import regeneratorRuntime from "/app/node_modules/.pnpm/regenerator-runtime@0.13.4/node_modules/regenerator-runtime/runtime.js";
import logger from 'common/utils/logger';
import { getConfig } from 'portal-common/config';
import { API_PROXY_PREFIX } from 'portal-common/constants';
import { CONFIG_KEYS, NAMESPACE } from 'portal-common/constants/requestConstants';
import { api } from 'portal-common/http';
import { buyLangMap } from '../common/constants';
import { getUserRemoteIP } from '../common/util';
import { getFormatUrlMethods } from '../components/OldRender/utils/url-utils';
import { getUserInfo } from './discountApi';
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {
        };
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}
export var getPriceTabData = _asyncToGenerator(regeneratorRuntime.mark(function _callee(lang, domains) {
    var langMap, sendLang, ref, data, code;
    return regeneratorRuntime.wrap(function _callee$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                langMap = buyLangMap;
                sendLang = langMap[lang] || lang;
                _ctx.next = 4;
                return api.call('https://buy.tencentcloud.com/cgi/v2/config/getPriceTabData', {
                    method: 'get',
                    params: {
                        csrfCode: '',
                        lang: sendLang
                    }
                });
            case 4:
                ref = _ctx.sent;
                data = ref.data;
                code = ref.code;
                if (code) {
                    _ctx.next = 9;
                    break;
                }
                return _ctx.abrupt("return", {
                    code: 0,
                    msg: '',
                    data: formatPriceTabData(data.blocks, domains)
                });
            case 9:
                return _ctx.abrupt("return", {
                    code: code,
                    msg: '数据请求出错'
                });
            case 10:
            case "end":
                return _ctx.stop();
        }
    }, _callee);
}));
export var verifyCoupon = _asyncToGenerator(regeneratorRuntime.mark(function _callee(param, req) {
    var eventId, ecId, captcha, _isValidate, isValidate, formInfo, ref, ip, ref1, ref2, randstr, ticket, API_PREFIX, config, res, captCode, returnCode, captData, ref3, _data, ownerUin, params;
    return regeneratorRuntime.wrap(function _callee$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                eventId = param.eventId, ecId = param.ecId, captcha = param.captcha, _isValidate = param.isValidate, isValidate = _isValidate === void 0 ? true : _isValidate, formInfo = param.formInfo;
                ;
                ip = getUserRemoteIP(req);
                if (!isValidate) {
                    _ctx.next = 21;
                    break;
                }
                ;
                ref2 = captcha || {
                }, randstr = ref2.randstr, ticket = ref2.ticket;
                API_PREFIX = "".concat(API_PROXY_PREFIX, "/").concat(NAMESPACE.OPM_API);
                _ctx.next = 9;
                return getConfig(CONFIG_KEYS.secretConfig);
            case 9:
                config = _ctx.sent;
                _ctx.next = 12;
                return api.call("".concat(API_PREFIX, "/api/tool/capi.comApi"), {
                    method: 'post',
                    body: {
                        cmd: 'DescribeCaptchaResult',
                        serviceType: 'captcha',
                        data: {
                            Action: 'DescribeCaptchaResult',
                            Version: '2019-07-22',
                            CaptchaType: 9,
                            Ticket: ticket,
                            UserIp: ip,
                            Randstr: randstr,
                            CaptchaAppId: config.captchaConf.appId,
                            AppSecretKey: config.captchaConf.secretKey
                        }
                    }
                });
            case 12:
                res = _ctx.sent;
                captCode = res.code, returnCode = res.returnCode, captData = res.data;
                logger.info('verifyCoupon params', {
                    DescribeCaptchaResult: res,
                    captCode: captCode,
                    captData: captData,
                    eventId: eventId,
                    ecId: ecId,
                    deviceIntelligence: {
                    },
                    uin: ((req === null || req === void 0 ? void 0 : (ref1 = req.cookies) === null || ref1 === void 0 ? void 0 : ref1.uin) || '').replace(/^o0*/, ''),
                    ip: ip,
                    ticket: ticket,
                    randstr: randstr,
                    appId: config.captchaConf.appId,
                    secretKey: config.captchaConf.secretKey
                });
                if (!(captCode !== 0 && returnCode !== 0)) {
                    _ctx.next = 18;
                    break;
                }
                logger.error('captCode', {
                    captCode: captCode,
                    returnCode: returnCode
                }, {
                }, logger.ErrorLevel.high);
                throw 'Intl Backend Service Error';
            case 18:
                if (!(captData.CaptchaCode !== 1)) {
                    _ctx.next = 21;
                    break;
                }
                logger.error('captData.CaptchaCode', _objectSpread({
                }, captData), {
                }, logger.ErrorLevel.high);
                throw 'Fake Request';
            case 21:
                _ctx.next = 23;
                return getUserInfo(req);
            case 23:
                ref3 = _ctx.sent;
                _data = ref3.data;
                ownerUin = _data.owner_uin;
                params = {
                    uin: ((req === null || req === void 0 ? void 0 : (ref = req.cookies) === null || ref === void 0 ? void 0 : ref.uin) || '').replace(/^o0*/, ''),
                    eventId: eventId,
                    ecId: ecId,
                    deviceIntelligence: {
                    },
                    system: {
                        ip: ip
                    },
                    ownerUin: String(ownerUin),
                    formInfo: formInfo
                };
                _ctx.next = 29;
                return FetchCommodity(params);
            case 29:
                return _ctx.abrupt("return", _ctx.sent);
            case 30:
            case "end":
                return _ctx.stop();
        }
    }, _callee);
}));
export var FetchCommodity = _asyncToGenerator(regeneratorRuntime.mark(function _callee(params) {
    var API_PREFIX, result;
    return regeneratorRuntime.wrap(function _callee$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                API_PREFIX = "".concat(API_PROXY_PREFIX, "/").concat(NAMESPACE.QCINTL_API);
                _ctx.next = 3;
                return api.call("".concat(API_PREFIX, "/portal-operation-event/drawCommodityCoupon"), {
                    body: params,
                    method: 'post'
                });
            case 3:
                result = _ctx.sent;
                logger.info('bugApi-FetchCommodity', {
                    params: params,
                    result: result
                });
                return _ctx.abrupt("return", result.data);
            case 6:
            case "end":
                return _ctx.stop();
        }
    }, _callee);
}));
var formatPriceTabData = function(data, domains) {
    var formatUrlString = getFormatUrlMethods({
        domains: domains
    }).formatUrlString;
    var ret = data.map(function(oneTab) {
        var title1 = oneTab.title, children = oneTab.children, doubleIcon = oneTab.doubleIcon;
        var childrenList = children.map(function(oneChild) {
            var title = oneChild.title, desc = oneChild.desc, to = oneChild.to, isCalcOnline = oneChild.isCalcOnline;
            return {
                title: title,
                text: desc,
                link: formatUrlString(to),
                hasCalculator: isCalcOnline
            };
        });
        return {
            title: title1,
            logo: doubleIcon,
            intro_list: childrenList
        };
    });
    return ret;
};
export var getRegisterStep = _asyncToGenerator(regeneratorRuntime.mark(function _callee(req) {
    var API_PREFIX, ref, code, _data, data, _uin, uin, isOwner, params, result;
    return regeneratorRuntime.wrap(function _callee$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                API_PREFIX = "/".concat(NAMESPACE.QCINTL_WOA_API);
                _ctx.next = 3;
                return getUserInfo(req);
            case 3:
                ref = _ctx.sent;
                code = ref.code;
                _data = ref.data;
                data = _data === void 0 ? {
                } : _data;
                _uin = data.uin, uin = _uin === void 0 ? '' : _uin, isOwner = data.isOwner;
                if (!(code === 0 && uin)) {
                    _ctx.next = 17;
                    break;
                }
                if (isOwner) {
                    _ctx.next = 11;
                    break;
                }
                return _ctx.abrupt("return", {
                    code: 0,
                    data: {
                        step: 999
                    }
                });
            case 11:
                params = req.body;
                params.uin = uin;
                _ctx.next = 15;
                return api.fetchMidProxy("".concat(API_PREFIX, "/intl-account-register/v1/GetIntlRegisterStep"), {
                    body: params,
                    method: 'post'
                });
            case 15:
                result = _ctx.sent;
                return _ctx.abrupt("return", result);
            case 17:
                return _ctx.abrupt("return", {
                    code: -1000,
                    msg: '获取用户信息出错'
                });
            case 18:
            case "end":
                return _ctx.stop();
        }
    }, _callee);
}));
// 查询领劵前置开户状态+绑卡情况
export var getBillAccountInfo = _asyncToGenerator(regeneratorRuntime.mark(function _callee(req) {
    var ref, code, _data, data, ownerUin, ref4, ref5, _data1, isOpen, ref6, total;
    return regeneratorRuntime.wrap(function _callee$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.next = 2;
                return getUserInfo(req);
            case 2:
                ref = _ctx.sent;
                code = ref.code;
                _data = ref.data;
                data = _data === void 0 ? {
                } : _data;
                ownerUin = data.owner_uin;
                if (!(code === 0 && ownerUin)) {
                    _ctx.next = 19;
                    break;
                }
                _ctx.t0 = _slicedToArray;
                _ctx.next = 11;
                return Promise.all([
                    getBillAccountIsOpenByUin({
                        uin: ownerUin
                    }),
                    getBillAccountPaymentMethod({
                        uin: ownerUin,
                        page: 1,
                        page_size: 10
                    }), 
                ]);
            case 11:
                _ctx.t1 = _ctx.sent;
                ref4 = (0, _ctx.t0)(_ctx.t1, 2);
                ref5 = ref4[0];
                _data1 = ref5.data;
                isOpen = _data1.is_open;
                ref6 = ref4[1];
                total = ref6.data.total;
                return _ctx.abrupt("return", {
                    isOpen: isOpen,
                    total: total
                });
            case 19:
                return _ctx.abrupt("return", {
                    code: -1000,
                    msg: '获取用户信息出错'
                });
            case 20:
            case "end":
                return _ctx.stop();
        }
    }, _callee);
}));
export var getBillAccountIsOpenByUin = _asyncToGenerator(regeneratorRuntime.mark(function _callee(params) {
    var API_PREFIX, result;
    return regeneratorRuntime.wrap(function _callee$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                API_PREFIX = "/".concat(NAMESPACE.QCINTL_WOA_API);
                _ctx.next = 3;
                return api.fetchMidProxy("".concat(API_PREFIX, "/backend-account-billing/v1/GetBillAccountIsOpenByUin"), {
                    body: params,
                    method: 'post'
                });
            case 3:
                result = _ctx.sent;
                logger.info('buyApi-getBillAccountIsOpenByUin', {
                    params: params,
                    result: result
                });
                return _ctx.abrupt("return", result);
            case 6:
            case "end":
                return _ctx.stop();
        }
    }, _callee);
}));
export var getBillAccountPaymentMethod = _asyncToGenerator(regeneratorRuntime.mark(function _callee(params) {
    var API_PREFIX, result;
    return regeneratorRuntime.wrap(function _callee$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                API_PREFIX = "/".concat(NAMESPACE.QCINTL_WOA_API);
                _ctx.next = 3;
                return api.fetchMidProxy("".concat(API_PREFIX, "/backend-account-billing/v1/GetBillAccountPaymentMethod"), {
                    body: params,
                    method: 'post'
                });
            case 3:
                result = _ctx.sent;
                logger.info('buyApi-getBillAccountPaymentMethod', {
                    params: params,
                    result: result
                });
                return _ctx.abrupt("return", result);
            case 6:
            case "end":
                return _ctx.stop();
        }
    }, _callee);
}));
